import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Navigate } from 'react-router-dom';

const KycGate = ({ children }) => {
  const { user } = useAuth();
  if (!user) return null;

  if (user.account_status === 'rejected') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] p-4">
        <div className="max-w-md w-full bg-[#121212] border border-red-500/30 rounded-sm p-8 text-center">
          <p className="text-red-400 text-2xl font-bold mb-2">Cuenta Rechazada</p>
          <p className="text-[#A1A1AA] text-sm">Tu cuenta fue rechazada por el administrador. Contacta a soporte para más información.</p>
        </div>
      </div>
    );
  }

  if (user.account_status === 'pending') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] p-4">
        <div className="max-w-md w-full bg-[#121212] border border-[#27272A] rounded-sm p-8 text-center">
          <p className="text-[#FFD600] text-2xl font-bold mb-2">Cuenta en Revisión</p>
          <p className="text-[#A1A1AA] text-sm">Tu cuenta está siendo revisada por el administrador. Te notificaremos cuando sea aprobada.</p>
        </div>
      </div>
    );
  }

  if (user.kyc_status === 'verified') return children;
  return <Navigate to="/kyc" replace />;
};
export default KycGate;
